import type { SVGProps } from 'react';
const SvgIconClock = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" d="M8 5a.75.75 0 0 1 .75.75v1.94l1.28 1.28a.75.75 0 1 1-1.06 1.06l-1.5-1.5A.75.75 0 0 1 7.25 8V5.75A.75.75 0 0 1 8 5" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 8.5v-1A6.5 6.5 0 0 1 7.5 1h1A6.5 6.5 0 0 1 15 7.5v1A6.5 6.5 0 0 1 8.5 15h-1A6.5 6.5 0 0 1 1 8.5m1.5 0a5 5 0 0 0 5 5h1a5 5 0 0 0 5-5v-1a5 5 0 0 0-5-5h-1a5 5 0 0 0-5 5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconClock;
